$('body').on('change', '.manage-owner .add-payment input[name="method"]', function () {
    var method = $(this).val();

    $('.manage-owner .add-payment .method').find('input, select').removeClass('required');
    $('.manage-owner .add-payment .method').find('input, select').prop('disabled', true);
    $('.manage-owner .add-payment .method').addClass('hidden');

    $('.manage-owner .add-payment .method[data-method="' + method + '"]').removeClass('hidden');
    $('.manage-owner .add-payment .method[data-method="' + method + '"]').find('input, select').prop('disabled', false);
    $('.manage-owner .add-payment .method[data-method="' + method + '"]').find('input, select').each(function () {
        var input = $(this);
        if (input.attr('data-required')) {
            input.addClass('required');
        }
    });
});

function calculateOwnerPayments(totalAmount = 0) {
    var date;

    $('.payment-item').each(function() {
        var paymentItem = $(this);
        var amount = parseFloat($('[name="amount[]"]', paymentItem).val());
        if(!isNaN(amount)) {
            totalAmount += amount;
        }

        if (!date && $('[name="payment_date[]"]', paymentItem).val()) {
            date = new Date($('[name="payment_date[]"]', paymentItem).val());
        }
    });

    // calcuate per payment
    var perPayment = totalAmount / $('.payment-item').length;
    $('.payment-item').each(function () {
        var paymentItem = $(this);
        $('[name="amount[]"]', paymentItem).val(perPayment.toFixed(2));
        $('[name="payment_date[]"]', paymentItem).val(date.toDateString());
        date.setMonth(date.getMonth() + 1);
    });
}

var ownerPaymentItem = `<div class="payment-item item">
    <a href="" class="remove-payment-item-trigger remove-item-trigger icon-trash" tabindex="-1"></a>
    <a href="" class="add-payment-item-trigger-before add-item-before-trigger icon-add" tabindex="-1"></a>

    <ul class="fields no-padding">
        <li class="quarter filled">
            <input type="tel" name="amount[]" class="required">
            <span>Amount</span>
        </li>

        <li class="quarter filled">
            <input type="text" name="payment_date[]" class="required mask" data-placeholder="YYYY-MM-DD" data-mask="9999-99-99">
            <span>Payment Date</span>
        </li>

        <li class="quarter">
            <input type="tel" name="check_number[]">
            <span>Check Number</span>
        </li>

        <li class="quarter last">
            <input type="text" name="notes[]">
            <span>Notes</span>
        </li>
    </ul>
</div>`;

$('body').on('click', '.manage-owner .status-payments .add-payment-item-trigger', function () {
    var $this = $(this);
    var payment = $this.parents('.status-payments');
    payment.find('.setup-items').append(ownerPaymentItem);
    if ($('[name="auto_calculate"]').prop('checked') ) {
        calculateOwnerPayments();
    }
    return false;
});

$('body').on('click', '.manage-owner .status-payments .add-payment-item-trigger-before', function () {
    var $this = $(this);
    // var payment = $this.parents('.status-payments');
    $this.parents('.payment-item').before(ownerPaymentItem);
    if ($('[name="auto_calculate"]').prop('checked')) {
        calculateOwnerPayments();
    }
    return false;
});

$('body').on('click', '.manage-owner .remove-payment-item-trigger', function () {
    var $this = $(this);
    if ($('.payment-item').length > 1) {
        var amount = parseFloat($('[name="amount[]"]', $('.payment-item')).val());
        if (isNaN(amount)) {
            amount = 0;
        }
        $this.parents('.payment-item').remove();
        if ($('[name="auto_calculate"]').prop('checked')) {

            calculateOwnerPayments(amount);
        }
    }
    return false;
});

$('body').on('click', '.manage-owner .add-qty', function () {
    var qty = parseInt($('.manage-owner .qty-wrapper input').val());
    var payment = $('.manage-owner .status-payments');
    if (isNaN(qty) || qty == 0) {
        return false;
    }

    for (let index = 0; index < qty; index++) {
        payment.find('.setup-items').append(yearSeatPaymentItem);
    }

    if ($('[name="auto_calculate"]').prop('checked')) {
        calculateSeatPayments();
    }

    return false;
});

// submit the payment
$('body').on('submit', '.manage-owner .add-payment form', function () {
    var $this = $(this);
    var card = $this.parents('.card');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };

    var error = false;

    card.find('.required').each(function () {
        if ($(this).val() === '') {
            error = true;
        }
    });

    if (error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }

    loading();
    $.ajax({
        type: 'POST',
        url: $this.attr('action'),
        data: fields,
        dataType: 'json',
        success: function (data) {
            console.log(data);
            unloading();

            if (!data.success) {
                showError('Error', data.message);
                return false;
            }

            $this[0].reset();
            showError('Success', data.message);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-owner', function (data) {
    if ($('.manage-owner[data-owner="' + data.owner + '"]').length) {
        var element = $('.manage-owner[data-owner="' + data.owner + '"]');

        // update the form
        element.find('.owner [name="name"]').val(data.name);
        element.find('.owner [name="hebrew_name"]').val(data.hebrew_name);
        element.find('.owner [name="street"]').val(data.street);
        element.find('.owner [name="apt"]').val(data.apt);
        element.find('.owner [name="city"]').val(data.city);
        element.find('.owner [name="state"]').val(data.state);
        element.find('.owner [name="zip"]').val(data.zip);
        element.find('.owner [name="email"]').val(data.email);
        element.find('.owner [name="phone"]').val(data.phone);
    }
});